import { render, staticRenderFns } from "./anquan.vue?vue&type=template&id=32e8cbe9&scoped=true&"
import script from "./anquan.vue?vue&type=script&lang=js&"
export * from "./anquan.vue?vue&type=script&lang=js&"
import style0 from "./anquan.vue?vue&type=style&index=0&id=32e8cbe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e8cbe9",
  null
  
)

export default component.exports